<template>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='reportList'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
    :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
    @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>
<script>
import { reactive, ref, toRefs } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'
import { iscode } from '@/utils/app'
import { getDeliveryTemplateLog } from "@/api/order";
export default {
  setup(){
      const state=reactive({
        listLoading:false,
        search:{
          limit:5,
          page:1
        },
        total:0
      })
      const columns=[
      {
        title: "导出时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "生成进度",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
        title: "数量",
        dataIndex: "num",
        key: "num"
      },
      ]
      const reportList=ref([])
      const getList=async ()=>{
        state.listLoading=true
          let result=await getDeliveryTemplateLog(state.search).then(res=>res.data).catch(error=>error)
        state.listLoading=false
        if(iscode(result)){
          reportList.value=result.data.data
          state.total=result.data.total
        }
      }
      onMounted(()=>{
        getList()
      })
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      state.search.page = page;
      getList();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      state.search.page = 1;
      state.search.limit = limit;
      getList();
    };
      return{
        ...toRefs(state),
        columns,
        reportList,
        pageCurrentChange,
        pageSizeChange
      }
  }
}
</script>